import { V as spread_attributes, P as pop, aa as sanitize_props, N as push, a9 as fallback, a1 as attr, a2 as stringify, T as escape_html, X as bind_props } from "./index.js";
import { o as onDestroy } from "./index-server.js";
import { c as checkIconState, g as generateIcon, h as html } from "./functions.js";
function Icon($$payload, $$props) {
  const $$sanitized_props = sanitize_props($$props);
  push();
  const state = {
    // Last icon name
    name: "",
    // Loading status
    loading: null,
    // Destroyed status
    destroyed: false
  };
  let mounted = false;
  let data;
  const onLoad = (icon) => {
    if (typeof $$sanitized_props.onLoad === "function") {
      $$sanitized_props.onLoad(icon);
    }
  };
  function loaded() {
  }
  onDestroy(() => {
    state.destroyed = true;
  });
  {
    const iconData = checkIconState($$sanitized_props.icon, state, mounted, loaded, onLoad);
    data = iconData ? generateIcon(iconData.data, $$sanitized_props) : null;
    if (data && iconData.classes) {
      data.attributes["class"] = (typeof $$sanitized_props["class"] === "string" ? $$sanitized_props["class"] + " " : "") + iconData.classes.join(" ");
    }
  }
  if (data) {
    $$payload.out += "<!--[-->";
    if (data.svg) {
      $$payload.out += "<!--[-->";
      $$payload.out += `<svg${spread_attributes({ ...data.attributes }, void 0, void 0, 3)}>${html(data.body)}</svg>`;
    } else {
      $$payload.out += "<!--[!-->";
      $$payload.out += `<span${spread_attributes({ ...data.attributes })}></span>`;
    }
    $$payload.out += `<!--]-->`;
  } else {
    $$payload.out += "<!--[!-->";
  }
  $$payload.out += `<!--]-->`;
  pop();
}
function Button($$payload, $$props) {
  const $$sanitized_props = sanitize_props($$props);
  push();
  let label = fallback($$props["label"], "");
  let secondaryLabel = fallback($$props["secondaryLabel"], "");
  let primary = fallback($$props["primary"], true);
  let startIcon = fallback($$props["startIcon"], "");
  let endIcon = fallback($$props["endIcon"], "");
  let background = fallback($$props["background"], "dark");
  let ref = fallback($$props["ref"], null);
  let offsetWidth = fallback($$props["offsetWidth"], 0);
  let size = fallback($$props["size"], 0);
  const paddingHorizontal = size * 4 + 16 + "px";
  const paddingVertical = size * 4 + 8 + "px";
  $$payload.out += `<div tabindex="0" role="button"${attr("class", `cursor-pointer transition-all group ${stringify(primary ? "bg-teal-500 text-white " + (background === "dark" ? "hover:bg-white hover:text-black" : "hover:bg-black hover:text-white") : "bg-teal-900/10 text-black " + (background === "dark" ? "text-white hover:bg-teal-500 hover:text-white" : "hover:bg-black hover:text-white"))} rounded-2xl hover:drop-shadow-2xl text-[${stringify(size * 4 + 18)}px] flex items-center ${stringify($$sanitized_props.class)}`)}${attr("style", `padding-left: ${stringify(paddingHorizontal)}; padding-right: ${stringify(paddingHorizontal)}; padding-top: ${stringify(paddingVertical)}; padding-bottom: ${stringify(paddingVertical)};`)}><div class="flex items-center space-x-2 flex-1 shrink min-w-0">`;
  if (startIcon) {
    $$payload.out += "<!--[-->";
    Icon($$payload, {
      icon: startIcon,
      style: "width: 24px; height: 24px; opacity: 70%;"
    });
  } else {
    $$payload.out += "<!--[!-->";
  }
  $$payload.out += `<!--]--> <div class="flex flex-col items-start gap-0 cursor-pointer text-left flex-1 shrink min-w-0 overflow-hidden"><div class="font-medium whitespace-nowrap text-md truncate flex-1 shrink w-full">${escape_html(label)}</div> `;
  if (secondaryLabel) {
    $$payload.out += "<!--[-->";
    $$payload.out += `<div class="opacity-70 text-xs sm:text-sm flex-1 truncate w-full">${escape_html(secondaryLabel)}</div>`;
  } else {
    $$payload.out += "<!--[!-->";
  }
  $$payload.out += `<!--]--></div> `;
  if (endIcon) {
    $$payload.out += "<!--[-->";
    Icon($$payload, {
      icon: endIcon,
      style: "width: 24px; height: 24px; opacity: 70%; flex-shrink: 0;"
    });
  } else {
    $$payload.out += "<!--[!-->";
  }
  $$payload.out += `<!--]--></div></div>`;
  bind_props($$props, {
    label,
    secondaryLabel,
    primary,
    startIcon,
    endIcon,
    background,
    ref,
    offsetWidth,
    size,
    paddingHorizontal,
    paddingVertical
  });
  pop();
}
export {
  Button as B,
  Icon as I
};
